import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/setting.actions';

@Injectable()
export class SettingsResolver {
  constructor(private store: Store<RootState>) {}

  resolve() {
    // (Re)Load when on /settings/barn
    this.store.dispatch(settingActions.loadBarnsRequest());

    return of(true);
  }
}
